﻿"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const actions_1 = require("./actions");
__export(require("./actions"));
const INITIAL_STATE = [];
exports.reducer = (state = INITIAL_STATE, action) => {
    if (action.type === actions_1.OrganizationActionTypes.UpdateOrganizations) {
        return action.payload;
    }
    else {
        return state;
    }
};
//# sourceMappingURL=index.js.map